/* eslint-disable global-require */
module.exports = [
  ...require('./Contact/i18n'),
  'marketplace.store._showcase.html.m11',
  'marketplace.store._showcase.html.m12',
  'marketplace.store._showcase.html.m13',
  'marketplace.store._showcase.html.m14',
  'marketplace.free.show.contact.m10',
];
